import React from 'react';

import { useBasketBlockerContext, useSelectedVariantContext } from '../../context/TreatmentSelectorContext';

import OutOfStockNotification from './OutOfStockNotification/OutOfStockNotification';
import AlreadyInBasketNotification from './AlreadyInBasketNotification/AlreadyInBasketNotification';
import BlockedByBasketNotification from './BlockedByBasketNotification/BlockedByBasketNotification';
import GenderNotification from './GenderNotification/GenderNotification';

interface Props {
    conditionSlug: string;
}

/**
 * Displays a single basket blocker at a time to the user. If there are no basket blockers.
 */
const Notifications = ({ conditionSlug }: Props) => {
    const selectedVariant = useSelectedVariantContext();
    const blockers = useBasketBlockerContext();

    const blocker = blockers.length ? blockers[0] : null;

    if (!blocker) {
        return null;
    }

    /* eslint-disable indent */
    /* eslint-disable no-case-declarations */
    switch (blocker.type) {
        case 'OUT_OF_STOCK':
            return (
                <OutOfStockNotification
                    conditionSlug={conditionSlug}
                    outOfStockMessage={selectedVariant?.out_of_stock_message}
                />
            );
        case 'ALREADY_IN_BASKET':
            return <AlreadyInBasketNotification />;
        case 'BLOCKED_BY_BASKET':
            return <BlockedByBasketNotification blockingBasketItems={blocker.data.blockingBasketItemNames} />;
        case 'GENDER_RESTRICTED':
            return <GenderNotification treatmentGender={blocker.data.treatmentGender} />;
        default:
            return null;
    }
    /* eslint-enable no-case-declarations */
    /* eslint-enable indent */
};

export default Notifications;
